import gameSettings from '../constants/gameSettings';

const gameObjectTypes = {
    LOOT_OBJECT: 'loot-object'
};

const lootOptions = {
    GOOD: 'good',
    BAD_TREE_LEFT: 'bad-tree-left',
    BAD_TREE_RIGHT: 'bad-tree-right',
    BAD_ROADBLOCK: 'bad-roadblock',
    BAD_HOLE: 'bad-hole',
    BAD_POLICE: 'bad-police',
    BAD_HOTDOG: 'bad-hotdog',
    BAD_SEWERAGE: 'bad-sewerage',
    BAD_LOG: 'bad-log',
    PROTECTION_1: 'protection-1',
    PROTECTION_2: 'protection-2',
    PROTECTION_3: 'protection-3'
};

const lootOptionsWeights = [
    16, // good
    2, // bad-tree-left
    2, // bad-tree-right
    2, // bad-roadblock
    2, // bad-hole
    0, // bad-police
    0, // bad-hotdog
    2, // bad-sewerage
    2, // bad-log
    2, // protection-1
    2, // protection-1
    2 // protection-3
];

const lootOptionsArray = Array.from(Object.keys(lootOptions));

// Получить случайное целое число от min до max
// eslint-disable-next-line no-unused-vars
const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// Получить случайный элемент массива с вероятностью взятой из weights
const getRandomElementWithWeight = (items, weights) => {
    if (items.length !== weights.length || !items.length) return false;

    const cumulativeWeights = [];

    for (let i = 0; i < weights.length; i += 1) {
        cumulativeWeights[i] = weights[i] + (cumulativeWeights[i - 1] || 0);
    }

    const maxCumulativeWeight = cumulativeWeights[cumulativeWeights.length - 1];
    const randomNumber = maxCumulativeWeight * Math.random();

    for (let itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
        if (cumulativeWeights[itemIndex] >= randomNumber) {
            return items[itemIndex];
        }
    }

    return false;
};

// Перемешать элементы массива
const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));

        [array[i], array[j]] = [array[j], array[i]];
    }
};

// Создать массив строк вида ['good' х 21, 'bad-police' x 3] и т.д
const generateLootArray = (lootAmountByType) => {
    const result = Object.entries(lootAmountByType).reduce((acc, [key, value]) => [...acc, ...new Array(value).fill(key)], []);

    result.forEach((objKey, index) => {
        if (objKey === 'random') {
            const optionKey = getRandomElementWithWeight(lootOptionsArray, lootOptionsWeights);

            result[index] = lootOptions[optionKey];
        }
    });

    shuffleArray(result);

    return result;
};

// Финальный результат. Создать массив с типом и временем добавления лута
export const generateLevelLootableObjects = () => {
    const {
        startDistance,
        finalDistance,
        speedOfGame,
        distanceBeforeStartAddingLoots,
        beforeFinishDistance,
        lootAmountByType,
        maxLootSpacingRandomnessFactor,
        lootAddingStepEndModifier
    } = gameSettings;

    const lootEndDistance = (finalDistance - beforeFinishDistance) * speedOfGame;
    const lootStartDistance = startDistance + distanceBeforeStartAddingLoots;
    const totalLootDistance = lootEndDistance - lootStartDistance;
    const totalLootAmount = Object.values(lootAmountByType).reduce((acc, val) => acc + val, 0);
    const lootArray = generateLootArray(lootAmountByType);

    /*
        Тут формула выведена из формулы суммы первых n членов арифметической прогрессии
        Эта сумма равна totalLootDistance
        Первый член прогрессии - lootAddingStepStart
        Полследний - lootAddingStepEnd, или lootAddingStepStart / lootAddingStepEndModifier
    */
    const lootAddingStepStart = (totalLootDistance * 2 * lootAddingStepEndModifier) / (totalLootAmount * (lootAddingStepEndModifier + 1));
    const lootAddingStepEnd = lootAddingStepStart / lootAddingStepEndModifier;
    const lootAddingStepIncrement = (lootAddingStepEnd - lootAddingStepStart) / totalLootAmount;

    // console.log('LEVEL GENERATION PROPS');
    // console.log(lootAddingStepStart, lootAddingStepEnd, lootAddingStepIncrement);
    // const checkCalculatedDistance = (lootAddingStepStart + lootAddingStepEnd) * 0.5 * totalLootAmount;
    // console.log(totalLootDistance, checkCalculatedDistance);

    let currentDistance = lootStartDistance;
    let currentLootAddingStep = lootAddingStepStart;

    const result = lootArray.map((lootType) => {
        let distanceToAddAt = currentDistance;

        if (distanceToAddAt > lootStartDistance) {
            const randomnessFactor = (getRandomInt(0, maxLootSpacingRandomnessFactor * 10) * 0.1).toFixed(1);

            distanceToAddAt -= currentLootAddingStep * randomnessFactor;
        }

        const lootObj = {
            distance: distanceToAddAt,
            type: gameObjectTypes.LOOT_OBJECT,
            option: lootType
        };

        currentDistance += currentLootAddingStep;
        currentLootAddingStep += lootAddingStepIncrement;

        return lootObj;
    });

    return result;
};

// Этот результат надо вернуть из api
// eslint-disable-next-line no-unused-vars
const RESULT_TO_RETURN_FROM_ENDPOINT = generateLevelLootableObjects();
